<template>
  <div class="panel panel--display u-m-auto u-mt-xx-large">
    <form @submit.prevent="submit">
      <h2>Terms and Conditions</h2>

      <p class="u-mb-medium">
        Please read these Terms and Conditions carefully before using the Services and/or the Blendr.io Solution.
      </p>

      <p class="u-mb-medium">
        By clicking the “I agree” button, you agree that your use of the Services and/or the Blendr.io Solution, and the processing of your Personal Data shall be governed by the Blendr.io Terms and Conditions.
      </p>

      <p class="u-mb-medium">
        View <a href="https://blendr.io/terms" target="_blank" rel="noopener">Terms and Conditions</a>
      </p>

      <div class="form-buttons">
        <button
          :disabled="loading"
          type="submit"
          class="btn btn--primary"
          style="width: 100%;"
        >
          <i v-if="loading" class="fas fa-spinner fa-spin fa-fw" />
          I Agree
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { axios } from '@qlik-trial/automations-ui'

export default {
  data() {
    return {
      loading: false,
    }
  },

  methods: {
    submit() {
      this.loading = true

      axios.post('/terms', {
        agree_terms: true,
      }).then(() => {
        setTimeout(() => window.location.reload(), 1000)
      })
    },
  },
}
</script>
